import React from 'react';
import classNames from 'classnames';

import { Card, CardContent } from '@material-ui/core';

/**
 * Render a genric Card with a title and a card content
 */
class DashCard extends React.Component {
    render() {
        const { title, children, className } = this.props;

        return (
            <Card className={classNames('card', className)}>
                <CardContent>
                    <div className="card-title">
                        <span>{title}</span>
                    </div>
                    {children}
                </CardContent>
            </Card>
        );
    }
}

export default DashCard;



// WEBPACK FOOTER //
// ./src/components/Cards/DashCard.js